import type { GlobalConfig } from '../@types/context/global-config.types';
import type { MyPageConfig } from '../@types/context/my-page-config.types';
import type { ProductConfig } from '../@types/context/product-config.types';
import type { ProductUnsecuredLoanConfig } from '../@types/context/product-unsecured-loan-config.types';
import type { SiteConfig } from '../@types/context/site-config.types';
import { contactAxoSeConfig } from './presets/contact-axo-se.config';
import { insuranceMypageSe } from './presets/insurance-mypage.config';
import { globalSe } from './presets/global-se.config';
import { myPageCcd2SeOptions } from './presets/mypage-ccd2-se.config';
import { myPageOffersConfig } from './presets/mypage-offers.config';
import { productConfigLimited } from './presets/product-config.preset';
import { organisationAxoSeConfig } from './presets/organisation-axo-se.config';
import { serviceTrustpilotAxoSeConfig } from './presets/service-trustpilot-axo-se.config';
import { serviceVwoUscoreConfig } from './presets/service-vwo-uscore.config';
import { unsecuredLoansBrokerCustomFields } from './presets/unsecured-loans-broker-custom-fields.config';
import { unsecuredLoansSeConfig } from './presets/unsecured-loans-se.config';

export const global: GlobalConfig = {
  brand: 'uscore.se',
  ...globalSe,
};

export const site: SiteConfig = {
  domain: 'uscore.se',
  name: 'uScore',
  affiliate: {
    hasOffersUrl:
      'https://go.axogroup.com/aff_c?offer_id=1502&aff_id=1121&aff_sub=landing',
  },
  theme: {
    name: 'uscore-light',
    brand: 'uscore.se',
  },
  path: {
    loansApply: '/soknad/forbrukslan',
    mypage: '/mina-sidor',
    mypageOverview: '/mina-sidor',
    mypageLoans: '/mina-sidor/lan',
    insurance: '/soknad/forsakring',
    ...insuranceMypageSe,
  },
  ...organisationAxoSeConfig,
  ...contactAxoSeConfig,
  services: {
    cms: {
      provider: 'prepr',
    },
    trustpilot: {
      ...serviceTrustpilotAxoSeConfig,
      businessUnitId: '6576cefc64112a770f8583c1',
    },
    gtm: 'GTM-W2M535G',
    ga: 'G-11JD8SWJM5',
    gtmScriptStrategy: 'lazyOnload',
    launchDarkly: {
      enabled: false,
    },
    cookieConsentManager: {
      provider: 'usercentrics',
      usercentrics: {
        settingsId: 'LiOjrjIgM8FG8A',
        crossDomainBridgeScriptStrategy: 'lazyOnload',
        autoBlockerScriptStrategy: 'lazyOnload',
        usercentricsScriptStrategy: 'lazyOnload',
      },
    },
    ...serviceVwoUscoreConfig,
  },
};

export const productUnsecuredLoan: ProductUnsecuredLoanConfig = {
  ...unsecuredLoansSeConfig,
  fields: unsecuredLoansBrokerCustomFields,
};

export const myPage: MyPageConfig = {
  options: {
    hasHighCostWarning: false,
    ...myPageOffersConfig,
    ...myPageCcd2SeOptions,
  },
};

export const product: ProductConfig = productConfigLimited;
